import * as React from 'react';

import * as styles from './styles.css';

interface ILayoutProps {
  /** Ширина закрашенной части. Можно передавать в любой ед.изм., рассчитывая значение вне этого комп-та */
  fillWidth: number | string;
}

export const Layout = React.forwardRef<HTMLDivElement, ILayoutProps>((props, ref) => {
  return (
    <div ref={ref} className={styles['track']}>
      <div className={styles['fill']} style={{ width: props.fillWidth }} />
    </div>
  );
});

Layout.displayName = 'Layout';
